"use client";

import { useState } from "react";
import { CheckCircle, Pencil, LucideIcon } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarTrigger,
} from "@/shadcnComponents/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcnComponents/ui/tooltip";
import mixpanel from "mixpanel-browser";
import { useNewCampaign } from "../../CustomHooks/NewCampaignHooks";
import { useGeneralSettings } from "@/Providers/General";
import { Button } from "@/shadcnComponents/ui/button";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

export function NewCampaignSidebar({
  List,
}: {
  List: { title: string; icon: LucideIcon }[];
}) {
  const generalState = useGeneralSettings();
  const {
    formData,
    setFormData,
    selectedCreators,
    previewData,
    formValidation,
    setCurrentStep,
    currentStep,
    openSuccessPage,
    completedStep,
  } = useNewCampaign();

  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();

  const handleClick = (index: number) => {
    {
      index >= 2
        ? index === 3 || index === 4
          ? selectedCreators?.length > 0 && previewData?.ExpectedSpendAmount > 0
            ? index === 4
              ? formValidation({ checkArray: [1, 2, 4] })
                ? setCurrentStep(index + 1)
                : ""
              : setCurrentStep(index + 1)
            : generalState?.showErrorToast("Please select Influencers")
          : currentStep === 4
          ? setCurrentStep(index + 1)
          : formValidation({ checkArray: [1, 2] })
          ? setCurrentStep(index + 1)
          : ""
        : setCurrentStep(index + 1);
    }
  };

  const handleSetName = (value) =>
    setFormData((prev) => {
      return {
        ...prev,
        campaignInfo: {
          ...prev.campaignInfo,
          campaignName: value,
        },
      };
    });

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="flex items-center justify-between  px-6 group-data-[collapsible=icon]:px-0">
        <div className="w-full">
          <Button
            className="gap-2 text-[#AFAFAF] text-sm not-italic font-medium leading-6"
            onClick={() => {
              mixpanel.track("Campaign Sidebar: Back To Dashboard - clicked");
              navigate("/Brand/DashBoard/AllCampaign");
            }}
            variant="link"
          >
            <IoMdArrowRoundBack />
            Back to Dashboard
          </Button>
        </div>
        <div className="flex items-center space-x-2 w-full h-full">
          <div className="flex w-[90%] group-data-[collapsible=icon]:hidden items-center">
            {isEditing ? (
              <input
                type="text"
                value={formData?.campaignInfo?.campaignName}
                onChange={(e) => handleSetName(e.target.value)}
                onBlur={() => setIsEditing(false)}
                autoFocus
                className="text-sm font-semibold truncate w-full bg-transparent border-none focus:outline-none focus:ring-0"
              />
            ) : (
              <h2 className="text-sm font-semibold truncate flex-grow">
                {formData?.campaignInfo?.campaignName}
              </h2>
            )}
            <button
              onClick={() => setIsEditing(true)}
              className="p-1 hover:bg-gray-200 rounded-full ml-2 flex-shrink-0"
            >
              <Pencil className="h-3 w-3 text-gray-500" />
            </button>
          </div>
          <SidebarTrigger className="group-data-[collapsible=icon]:mx-auto" />
        </div>
      </SidebarHeader>
      <SidebarContent className="w-full bg-[#FFFFFF]">
        <TooltipProvider>
          <SidebarMenu>
            {List.map((item, index) => (
              <SidebarMenuItem
                key={item.title}
                className="w-full cursor-pointer"
              >
                <Tooltip>
                  <TooltipTrigger asChild>
                    <SidebarMenuButton asChild>
                      <div
                        onClick={() => {
                          !openSuccessPage ? (
                            <>
                              {mixpanel.track(
                                `Brand Campaign Sidebar: ${item?.title} - clicked`
                              )}
                              {handleClick(index)}{" "}
                            </>
                          ) : (
                            ""
                          );
                        }}
                        className={`flex items-center justify-between px-3 py-2 w-full ${
                          currentStep === index + 1
                            ? "bg-green-50 hover:bg-green-100"
                            : ""
                        } group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:!size-full`}
                      >
                        <span className="flex items-center truncate group-data-[collapsible=icon]:justify-center">
                          <item.icon className="mr-2 h-4 w-4 flex-shrink-0 group-data-[collapsible=icon]:mr-0" />
                          <span className="truncate text-sm group-data-[collapsible=icon]:hidden">
                            {item.title}
                          </span>
                        </span>
                        {(completedStep?.includes(index + 1) ||
                          openSuccessPage) && (
                          <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0 ml-1 group-data-[collapsible=icon]:hidden" />
                        )}
                      </div>
                    </SidebarMenuButton>
                  </TooltipTrigger>
                  <TooltipContent side="right" align="center">
                    <p>{item.title}</p>
                  </TooltipContent>
                </Tooltip>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </TooltipProvider>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
